import { z } from 'zod'

export const Identity = z.object({
  id: z.string(),
  email: z.string(),
  name: z.string().optional(),
  is_primary: z.boolean().optional(),
  verified: z.boolean().optional()
})

export type Identity = z.infer<typeof Identity>

export const IdentityListResponse = z.object({
  identities: z.array(Identity)
})

export type IdentityListResponse = z.infer<typeof IdentityListResponse>

export const CreateIdentityRequest = z.object({
  email: z.string(),
  name: z.string().optional()
})

export type CreateIdentityRequest = z.infer<typeof CreateIdentityRequest>
